
<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children && permissionExists(item.permission) && hasVisibleChild(item)"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-for="(child, i) in item.children">
              <v-list-item
                v-if="permissionExists(child.permission)"
                :key="i"
                link
                @click.prevent="child.action"
              >
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content :key="child.text">
                  <v-list-item-title>{{ child.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-group>
          <v-list-item
            v-else-if="permissionExists(item.permission)"
            :key="item.text"
            link
            @click.prevent="item.action"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <v-card-title>{{ userName }} </v-card-title>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">DiQcare2.0-Satkhira</span>
      </v-toolbar-title>
      <v-text-field
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Search"
        class="hidden-sm-and-down"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
      <v-btn icon large>
        <v-avatar size="32px" item>
          <v-img
            src="https://cdn.vuetifyjs.com/images/logos/logo.svg"
            alt="Vuetify"
          ></v-img>
        </v-avatar>
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import "vuejs-noty/dist/vuejs-noty.css";
import atshq from "../js/setup";
import PermissionName from "../js/PermissionName";
export default {
  props: {
    source: String,
  },
  methods: {
    menuPermissionVisible(permission_id) {
      return this.checkPermissionHasOrNot(permission_id);
    },
    permissionExists(permission_id) {
      return this.menuPermissionVisible(permission_id);
    },
    hasVisibleChild(item) {
      if (!item.children || !item.children.length) {
        return false;
      }
      return item.children.some((child) => this.menuPermissionVisible(child.permission));
    },
  },
  computed: {
    userName() {
      // return this.$store.getters.getUserName;

      return localStorage.getItem("userName");
    },
  },
  data() {
    return {
      apiUrl: atshq.defaults.headers.common.api_URL,
      baseUrl: atshq.defaults.headers.common.base_URL,
      returnUrl: atshq.defaults.headers.common.app_URL,
      dialog: false,
      drawer: null,
      items: [
        {
          icon: "mdi-home",
          text: "Home",
          action: () => {
            this.$router.push("/");
          },
        },
        {
          icon: "mdi-plus",
          text: "Patient Create",
          action: () => {
            this.$router.push("/patient-create").catch(() => {});
          },
        },
        {
          icon: "mdi-contacts",
          text: "Patients",
          action: () => {
            this.$router.push("/patients");
          },
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Appointment",
          model: this.first_node == "services" ? true : false,
          action: () => {},
          children: [
            {
              icon: "mdi-plus",
              text: "List",
              auth: true,
              action: () => {
                this.$router.push("/appointment/all").catch(() => {});
              },
            },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          leftIcon: "mdi-prescription",
          text: "Prescriptions",
          action: () => {},
          children: [
            {
              icon: "mdi-format-list-bulleted",
              text: "List",
              action: () => {
                this.$router.push("/prescription/List").catch(() => {});
              },
            },
            {
              icon: "mdi-calendar-clock",
              text: "Followup",
              action: () => {
                this.$router.push("/prescription/followup-patients").catch(() => {});
              },
            },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Invoices",
          model: false,
          action: () => {},
          children: [
            {
              icon: "mdi-plus",
              text: "Item List",
              auth: true,
              action: () => {
                this.$router.push("/invoices").catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Due List",
              auth: true,
              action: () => {
                this.$router.push("/invoice/due-list").catch(() => {});
              },
            },
            {
              icon: "mdi-close-circle-outline",
              text: "Void List",
              action: () => {
                this.$router.push("/invoice/void-list").catch(() => {});
              },
            },
          ],
        },
        // {
        //   icon: "mdi-contacts",
        //   "icon-alt": "mdi-chevron-down",
        //   text: "Outdoor Patient",
        //   model: false,
        //   action: () => {},
        //   children: [
        //     {
        //       icon: "mdi-plus",
        //       text: "Create Invoice",
        //       action: () => {
        //         this.$router.push("/opd/opd-invoice-create").catch(() => {});
        //       },
        //     },
        //
        //     {
        //       icon: "mdi-plus",
        //       text: "All",
        //       action: () => {
        //         this.$router.push("/ot-module/schedule").catch(() => {});
        //       },
        //     },
        //   ],
        // },
        {
          icon: "mdi-account-box-multiple",
          text: "OT Schedule",
          action: () => {
            this.$router.push("/ot-module/schedule").catch(() => {});
          },
        },

        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "OT Bill",
          model: false,
          action: () => {},
          children: [
            {
              icon: "mdi-plus",
              text: "All",
              action: () => {
                this.$router.push("/otbill-list").catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Operation",
              action: () => {
                this.$router.push("/ot-bill").catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Injection",
              action: () => {
                this.$router.push("/ot-bill/injection").catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Cancel List",
              action: () => {
                this.$router.push("/ot-module/ot-bill-cancel").catch(() => {});
              },
            },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Lens",
          model: false,
          action: () => {},
          children: [
            {
              icon: "mdi-plus",
              text: "Items",
              action: () => {
                this.$router.push("/lens-module/items").catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Inventory",
              action: () => {
                this.$router.push("/").catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Used Report",
              action: () => {
                this.$router.push("/lens-module/used-report").catch(() => {});
              },
            },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "OT Counseling ",
          model: false,
          action: () => {},
          children: [
            {
              icon: "mdi-plus",
              text: "All",
              action: () => {
                this.$router.push("/ot-module/counselor").catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Data",
              action: () => {
                this.$router.push("/ot-module/counseling-data").catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Incentive",
              action: () => {
                this.$router
                  .push("/ot-module/counselor-incentive")
                  .catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Report",
              action: () => {
                this.$router
                  .push("/ot-counseling/counselor-report")
                  .catch(() => {});
              },
            },

          ],
        },
        /* Cabin Information */
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          leftIcon: "mdi-camera-rear-variant",
          text: "Cabin & Booking List",
          action: () => {},
          children: [
            {
              icon: "mdi-format-list-bulleted",
              text: "Cabin List",
              auth: true,
              action: () => {
                this.$router.push("/cabin-list").catch(() => {});
              },
            },
          ],
        },
        /* Cabin Information */
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "OT Setup",
          model: false,
          action: () => {},
          children: [
            {
              icon: "mdi-plus",
              text: "OT Items",
              action: () => {
                this.$router.push("/ot-module/ot-items").catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Incentive",
              action: () => {
                this.$router
                  .push("/otbill-setup/counselor-incentive-setup")
                  .catch(() => {});
              },
            },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          leftIcon: "mdi-folder-image",
          text: "File Manager",
          model: false,
          action: () => {},
          children: [
            {
              icon: "mdi-cloud-upload",
              text: "QRCODE Data",
              action: () => {
                this.$router
                    .push("/file-manager/qrcode-data").catch(() => {});
              },
            },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Ledger",
          model: false,
          action: () => {
          },
          children: [
            {
              icon: "mdi-plus",
              text: "Hospital Ledger",
              action: () => {
                this.$router.push("/hospital-ledger").catch(() => {
                });
              },
            },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Card",
          model: false,
          action: () => {},
          children: [
            {
              icon: "mdi-plus",
              text: "Dashboard",
              action: () => {
                this.$router.push("/card/dashboard").catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Item List",
              action: () => {
                this.$router.push("/card").catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Assign",
              action: () => {
                this.$router.push("/card/assign").catch(() => {});
              },
            },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Investigation",
          model: false,
          action: () => {},
          children: [
            {
              icon: "mdi-plus",
              text: "All",
              action: () => {
                this.$router.push("/investigations").catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Report",
              action: () => {
                this.$router.push("/investigation/report").catch(() => {});
              },
            },
            {
              icon: "mdi-plus",
              text: "Discount Report",
              action: () => {
                this.$router
                    .push("/referrals/investigation-doctor-referral-report")
                    .catch(() => {});
              },
            },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Reports",
          model: false,
          action: () => {
          },
          children: [
            // {
            //   icon: "mdi-plus",
            //   text: "Payment Report",
            //   action: () => {
            //     this.$router.push("/reports/payment-report").catch(() => {
            //     });
            //   },
            // },
            {
              icon: "mdi-plus",
              text: "Invoice Report",
              action: () => {
                this.$router.push("/reports/invoice-report").catch(() => {
                });
              },
            },
            // {
            //   icon: "mdi-plus",
            //   text: "Discount Report",
            //   action: () => {
            //     this.$router.push("/reports/discount-report").catch(() => {
            //     });
            //   },
            // },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Doctors",
          model: false,
          action: () => {},
          children: [
            {
              icon: "mdi-account-multiple",
              text: "All",
              action: () => {
                this.$router.push("/doctors").catch(() => {});
              },
            },
            {
              icon: "mdi-cash-100",
              text: "Ledger",
              action: () => {
                this.$router.push("/doctor-ledger").catch(() => {});
              },
            },
            {
              icon: "mdi-cash",
              text: "Payment Statement",
              permission: PermissionName.DOCTOR_PAYMENT_STATEMENT,
              action: () => {
                this.$router.push("/doctor-payment-statement").catch(() => {});
              },
            },
            {
              icon: "mdi-format-list-bulleted",
              text: "Payment List",
              action: () => {
                this.$router.push("/doctor-payment").catch(() => {});
              },
            },

          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          leftIcon: "mdi-email",
          text: "SMS",
          model: false,
          action: () => {
          },
          children: [
            {
              icon: "mdi-clipboard-text",
              text: "DLR Report",
              action: () => {
                this.$router.push("/sms/drl-report").catch(() => {
                });
              },
            },
            {
              icon: "mdi-email",
              text: "Campaign Data",
              action: () => {
                this.$router.push("/sms/camp-data").catch(() => {
                });
              },
            },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Users & Roles",
          // permission: PermissionName.USERS_ROLES,
          model: false,
          action: () => {
          },
          children: [
            {
              icon: "mdi-account-multiple",
              text: "User List",
              permission: PermissionName.USER_LIST,
              action: () => {
                this.$router.push("/users/user-list").catch(() => {
                });
              },
            },
            {
              icon: "mdi-cash-100",
              text: "User Ledger",
              action: () => {
                this.$router.push("/users/user-ledger").catch(() => {
                });
              },
            },
            {
              icon: "mdi-plus",
              text: "Group List",
              permission: '',
              action: () => {
                this.$router.push("/users/group-list").catch(() => {
                });
              },
            },

            {
              icon: "mdi-account-key",
              text: "Role List",
              permission: PermissionName.ROLE_LIST,
              action: () => {
                this.$router.push("/users/role-list").catch(() => {
                });
              },
            },
          ],
        },
        {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: "Administrative",
          model: false,
          action: () => {
          },
          children: [
            {
              icon: "mdi-plus",
              text: "Chamber Info",
              action: () => {
                this.$router.push("/administrative/chamber-info").catch(() => {
                });
              },
            },
            {
              icon: "mdi-plus",
              text: "Payment Method Setup",
              action: () => {
                this.$router.push("/administrative/payment-method-setup").catch(() => {
                });
              },
            },
            {
              icon: "mdi-plus",
              text: "Fee & Ratio Setup",
              action: () => {
                this.$router.push("/administrative/fee-and-ratio-setup").catch(() => {
                });
              },
            },
            {
              icon: "mdi-plus",
              text: "Corporate Client Setup",
              action: () => {
                this.$router.push("/administrative/corporate-client-setup").catch(() => {
                });
              },
            },
            {
              icon: "mdi-plus",
              text: "OT Room Setup",
              action: () => {
                this.$router.push("/administrative/ot-room-setup").catch(() => {
                });
              },
            },
            {
              icon: "mdi-plus",
              text: "OPTIC LENS SETUP",
              action: () => {
                this.$router.push("/administrative/optic-lens-setup").catch(() => {
                });
              },
            },
            {
              icon: "mdi-plus",
              text: "Investigation Setup",
              action: () => {
                this.$router.push("/administrative/investigation-setup").catch(() => {
                });
              },
            },
          ],
        },
        {
          icon: "mdi-history",
          text: "Return to Menu",
          action: () => {
            window.open(atshq.defaults.headers.common.app_URL);
          },
        },
        {
          icon: "mdi-logout",
          text: "Logout",
          action: () => {
            this.$router.push("/logout").catch(() => {});
          },
        },

      ],
    };
  },
};
</script>
<style>
.v-list-group__items {
  margin-left: 60px;
}
/* 
.theme--light.v-navigation-drawer {
  background-color: #fff;
  width: 100% !important;
}
.v-list-item {
  display: inline-flex !important;
}
.theme--light.v-sheet {
  background-color: #fff;
  border-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  display: inline-flex !important;
}
.v-navigation-drawer__content {
  height: 130px !important;
  overflow-y: auto;
}

.v-navigation-drawer {
  height: 130px !important;
}
.v-main {
  margin-top: 130px;
  padding: 40px 0px 0px 10px!important;
}
.v-main__wrap {
  padding-left: 0px;
} */
</style>